import { useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import "@/App.css";
import BootLoader from "@/components/BootLoader";
import CRTOverlay from "@/components/CRTOverlay";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import MarqueeRibbon from "@/components/MarqueeRibbon";
import About from "@/components/About";
import Tokenomics from "@/components/Tokenomics";
import Roadmap from "@/components/Roadmap";
import HowToBuy from "@/components/HowToBuy";
import Community from "@/components/Community";
import Footer from "@/components/Footer";

function App() {
  const [booted, setBooted] = useState(false);
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (id) =>
    lenisRef.current?.scrollTo(id, { offset: -72, duration: 1.4 });

  return (
    <div
      data-testid="app-root"
      className="min-h-screen overflow-x-clip bg-nox text-[#E0E0E0]"
    >
      <CRTOverlay />
      <AnimatePresence>
        {!booted && <BootLoader onDone={() => setBooted(true)} />}
      </AnimatePresence>
      <Navbar booted={booted} onNavigate={scrollTo} />
      <main>
        <Hero booted={booted} onNavigate={scrollTo} />
        <MarqueeRibbon />
        <About />
        <Tokenomics />
        <Roadmap />
        <HowToBuy />
        <Community />
      </main>
      <Footer onNavigate={scrollTo} />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0C120C",
            border: "1px solid #39FF14",
            color: "#E0E0E0",
            fontFamily: '"JetBrains Mono", monospace',
            borderRadius: "2px",
          },
        }}
      />
    </div>
  );
}

export default App;
